<template>
  <path
    id="pdf"
    d="M20.0000156,15 L20.0000156,6 L17.0000156,6 C15.8969531,6 15,5.10304687 15,4.00003125 L15,1.00003125 L5.00001563,1.00003125 C4.44876563,1.00003125 4.00003125,1.44876562 4.00003125,2.00001562 L4.00003125,21.9999844 C4.00003125,22.5512344 4.44876563,22.9999688 5.00001563,22.9999688 L19.0000312,22.9999688 C19.5512813,22.9999688 20.0000156,22.5512344 20.0000156,21.9999844 L20.0000156,16 L4,16 L4,15 L20.0000156,15 Z M20.8535156,5.1465 C20.9472656,5.24025 21,5.3671875 21,5.49998438 L21,21.9999844 C21,23.1030469 20.1030469,24 19.0000312,24 L5.00001562,24 C3.89695313,24 3,23.1030469 3,22.0000312 L3,2.00001563 C3,0.896953125 3.89695313,0 4.99996875,0 L15.4999688,0 C15.6328125,0 15.75975,0.052734375 15.8535,0.146484375 L20.8535156,5.1465 Z M15.9999844,1.70704687 L15.9999844,4.00003125 C15.9999844,4.55128125 16.4487188,5.00001562 16.9999688,5.00001562 L19.2929531,5.00001562 L15.9999844,1.70704687 Z M8.15041783,21 L8.15041783,17.6103093 L7,17.6103093 L7,17 L10,17 L10,17.6103093 L8.83844011,17.6103093 L8.83844011,21 L8.15041783,21 Z M11.1367188,21 L11.1367188,17 L11.8632812,17 L11.8632812,21 L11.1367188,21 Z M13,21 L13,17 L16,17 L16,17.6103093 L13.7791798,17.6103093 L13.7791798,18.8061856 L15.6435331,18.8061856 L15.6435331,19.4164948 L13.7791798,19.4164948 L13.7791798,21 L13,21 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'TiffIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
